module.exports = __webpack_public_path__ + "img/area-part3-411.2ecf9063.png";